export default function AppSection() {
  return (
    <section id="app" className="relative w-full py-16 md:py-20 bg-background-100 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-primary-500/5 via-transparent to-accent-500/5 pointer-events-none"></div>
      <div className="relative max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[900px] mx-auto">
          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12 bg-background-200/50 rounded-2xl border border-background-300/40 p-8 md:p-10">
            <div className="flex-shrink-0 w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-primary-500/10 flex items-center justify-center border border-primary-500/20">
              <i className="ri-smartphone-line text-4xl md:text-5xl text-primary-400"></i>
            </div>
            <div className="flex-1 text-center md:text-left">
              <h2 className="text-xl md:text-2xl font-black text-foreground-50 mb-3">随时随地，高清追剧</h2>
              <p className="text-foreground-300 leading-relaxed text-sm md:text-base mb-5">
                香蕉影视移动端完美适配手机与平板，支持 iOS 和 Android 双平台。
                无论通勤路上、午休间隙还是睡前时光，打开浏览器即刻观影，无需下载安装，
                高清画质自适应网络环境，流畅不卡顿，让你的追剧体验不受时空限制。
              </p>
              <div className="flex flex-wrap items-center justify-center md:justify-start gap-3">
                <a href="#hero" className="inline-flex items-center gap-2 px-6 py-2.5 bg-foreground-50 hover:bg-foreground-100 text-background-950 font-semibold rounded-lg text-sm transition-all duration-200 whitespace-nowrap cursor-pointer">
                  <i className="ri-apple-line text-lg"></i>iOS 网页版
                </a>
                <a href="#hero" className="inline-flex items-center gap-2 px-6 py-2.5 bg-secondary-500 hover:bg-secondary-600 text-background-950 font-semibold rounded-lg text-sm transition-all duration-200 whitespace-nowrap cursor-pointer">
                  <i className="ri-android-line text-lg"></i>Android 网页版
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}